import React from 'react';

import type { BeraReportV2SelectedFactor } from '@/types/Bera';

import { toFactorText } from './utils';
import { Cell, CellHeader, CellValue } from './styles';

interface FactorCellProps {
	label: string;
	factor: BeraReportV2SelectedFactor;
	separator: boolean;
}

export function FactorCell({ label, factor, separator }: Readonly<FactorCellProps>): JSX.Element {
	return (
		<Cell separator={separator}>
			<CellHeader>{label}</CellHeader>
			<CellValue>{toFactorText(factor)}</CellValue>
		</Cell>
	);
}
